import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import moment from "moment";
import { Padding } from "@mui/icons-material";
import JisTabButton from "../../components/controls/jisTabButton";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";

function CfoSwearingSheriffSubstituted() {
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);

  const [docs, setDocs] = useState([]);
  const [cases, setCases] = useState([]);
  const [refs, setRefs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [casetype, setCaseType] = useState("litigation");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isSchedule, setIsSchedule] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [tab, setTab] = useState("pending");
  const navigate = useNavigate();

  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
  }, [pageIndex, pageSize, search, tab]);

  const onView = (item) => {
    navigate(`/prepare-document/${item.id}/cfo`);
  };

  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/eswearing-sheriff-substituted-cfo-cases/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onSelectSchedule = (doc) => {
    setIsSchedule(true);
    console.log(doc);

    setSchedule({ ...schedule, doc });
  };
  const onSaveSchedule = (e) => {
    e.preventDefault();
    console.log(schedule);
    var sch = {
      docid: schedule?.doc.id,
      zoomLink: schedule.zoom,
      scheduledBy: profile.username,
      scheduleDate: schedule.date + " " + schedule.time,
    };

    const uploadurl = `${Constants.apiUrl}/filing/e-swearing/schedule/${schedule.doc.id}`;
    const formData = new FormData();

    // Sending the FormData using fetch
    setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(sch),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          //saved already
          //first upldate the row and show dialog box
          //setCases(cases.map(i => i.docupload[0].id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, schedule:sch.scheduleDate} : i));
          setCases((prevCases) =>
            prevCases.map((i) => {
              if (i.id === schedule.doc.id) {
                return {
                  ...i,
                  schedule: sch.scheduleDate,
                  zoomLink: sch.zoomLink,
                };
              }
              return i;
            }),
          );
          setSchedule({});

          setAlert({
            open: true,
            title: "Schedule an Appointment",
            subtitle: "Meeting Schedule is successful",
          });
          setIsSchedule(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };
  const onChangeTab = (t) => {
    setTab(t);
    setPageIndex(0);
  };
  return (
    <div>
      <div>
        <CustomSearchSortHeader
          onSearch={onSearch}
          frequentData={frequentData}
        />
        {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
        <div className="tab_body">
          <div className="tab_section" style={{ marginBottom: 20 }}>
            <JisTabButton
              isActive={tab == "pending"}
              title="Pending"
              isRoleBased={false}
              onClick={() => onChangeTab("pending")}
            />
            <JisTabButton
              isActive={tab == "scheduled"}
              title="Scheduled"
              isRoleBased={false}
              onClick={() => onChangeTab("scheduled")}
            />
            <JisTabButton
              isActive={tab == "completed"}
              title="Commissioned"
              isRoleBased={false}
              onClick={() => onChangeTab("completed")}
            />
          </div>
          <div className="tab_view">
            <div className="table">
              <div class="section-cases">
                <span>E-Swearing Cases</span>
              </div>
              <table class="case-table">
                <thead>
                  <tr>
                    {/* <th className="col-id">ID</th> */}

                    <th>Suite Number</th>
                    <th className="col-title"> Title</th>
                    {tab === "completed" ? (
                      <>
                        <td>Date Created</td>
                        <td>Type</td>
                        <th>Commissioned Date</th>
                        <th>Time</th>
                        <th className="col-title">Virtual</th>
                      </>
                    ) : (
                      <>
                        <th className="col-medium">Schedule Date and Time</th>
                        <th className="col-title">Zoom Link</th>
                        <th className="col-medium">Schedule</th>
                      </>
                    )}
                    <th className="col-action">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {cases?.map((item, id) => {
                    return (
                      <tr key={id}>
                        {/*  <td>{item.id}</td> */}
                        <td
                          style={{
                            backgroundColor: `${
                              Constants.getItemById(
                                frequentData?.casecategories,
                                item.case.caseCategoryId,
                              )?.colour
                            }`,
                          }}
                        >
                          {" "}
                          {item.case.caseNumber ?? item.case.referenceNumber}
                        </td>
                        <td>{item.case.caseTitle}</td>
                        {tab === "completed" ? (
                          <>
                            <td>{item.createDate?moment(item.createDate).format(
                                    "Do MMMM, YYYY",
                                  ):"N/A"}</td>
                            <td>
                              {" "}
                              {Constants.getItemById(
                                frequentData?.casetype,
                                item.case.caseTypeId,
                              )?.caseType1 || "N/A"}
                            </td>
                            <td>
                              {item.completeDate
                                ? moment(item.completeDate).format(
                                    "Do MMMM, YYYY",
                                  )
                                : "N/A"}
                            </td>
                            <td>
                              {item.completeDate
                                ? moment(item.completeDate).format("h:mm a")
                                : "N/A"}
                            </td>
                            <td>
                                {item.isVirtual
                                ? "Zoom Call"
                                : "No Zoom"}
                              </td>
                            <td className="view-affbtn">
                              <div
                                className="selected"
                                onClick={() => onView(item)}
                              >
                                View Documents Attached
                              </div>
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              className={
                                item.schedule != null
                                  ? "date-time"
                                  : "date-time pends"
                              }
                            >
                              {tab === "pending" && "N/A"}
                              {tab === "scheduled" &&
                                (item.schedule != null
                                  ? moment(item.schedule).format(
                                      "dddd, MMMM Do YYYY h:mm a",
                                    )
                                  : "No scheduled date")}
                            </td>
                            <td
                              className={
                                item.schedule != null ? "zoom" : "zoom pends"
                              }
                            >
                              {item.zoomLink != null && (
                                <a href={item.zoomLink} target="_blank">
                                  {" "}
                                  Zoom Link{" "}
                                </a>
                              )}{" "}
                            </td>
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onSelectSchedule(item)}
                              >
                                Schedule
                              </JisButton>
                            </td>
                            <td>
                              {" "}
                              <JisButton
                                variant="plain"
                                className="black"
                                onClick={() => onView(item)}
                              >
                                View Documents Attached
                              </JisButton>
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <BackLoader open={loading} />
      {isSchedule && (
        <div className={"preview open"}>
          <form onSubmit={onSaveSchedule}>
          <div style={{ Padding: 16 }}>
            <div className="heading">
              <h2>e-Swearing Appointment </h2>
            </div>
            <div className="input-group">
              <label>
                Zoom Link <span className="required">*</span>{" "}
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="group" />
                <input
                  placeholder="Zoom Link"
                  required={true}
                  type="url"
                  value={schedule.zoom}
                  onChange={(e) =>
                    setSchedule({ ...schedule, zoom: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="input-group">
              <label>
                Zoom meeting date <span className="required">*</span>{" "}
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="group" />
                <input
                  placeholder="Schedule Date"
                  type="date"
                  required={true}
                  value={schedule.date}
                  onChange={(e) =>
                    setSchedule({ ...schedule, date: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="input-group">
              <label>
                Zoom meeting time <span className="required">*</span>{" "}
              </label>
              <div className="input-wrapper">
                <DynamicIcon iname="group" />
                <input
                  type="time"
                  placeholder="Zoom meeting time"
                  value={schedule.time}
                  onChange={(e) =>
                    setSchedule({ ...schedule, time: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="btngr">
              <JisButton
                icon="close"
                variant={"outline"}
                onClick={() => setIsSchedule(false)}
              >
                Cancel
              </JisButton>
              <JisButton icon="check_circle" type="submit" >
                Schedule Appointment
              </JisButton>
            </div>
          </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default CfoSwearingSheriffSubstituted;
